export { default } from './UnscoredCategoryPageBackgroundTextureProsAndConsSection'
